import React from "react";
import { useState } from "react";
import { Accordion, Flowbite } from "flowbite-react";

function Faq(props) {
    const [faq, setFaq] = useState([
        {
            title: "Hours",
            desc: (
                <div className="flex justify-center ">
                    <div className="w-4/5 md:w-60 flex flex-col justify-center">
                        <div className="flex justify-between">
                            <div>Monday:</div>
                            <div>Closed</div>
                        </div>

                        <div className="flex justify-between">
                            <div>Tuesday:</div>
                            <div>9AM - 3PM</div>
                        </div>

                        <div className="flex justify-between">
                            <div>Wednesday:</div>
                            <div>9AM - 3PM</div>
                        </div>
                        <div className="flex justify-between">
                            <div>Thursday:</div>
                            <div>9AM - 3PM</div>
                        </div>
                        <div className="flex justify-between">
                            <div>Friday:</div>
                            <div>9AM - 7PM</div>
                        </div>
                        <div className="flex justify-between">
                            <div>Saturday:</div>
                            <div>Closed</div>
                        </div>
                    </div>
                </div>
            ),
        },
        {
            title: "Before your wax...",
            desc: "1. Grow Out Your Hair - Allow your hair to grow to about 1/4 inch (about the size of a grain of rice).This length is ideal for the wax to grip the hair effectively. \n \n 2. Exfoliate Your Skin - Exfoliate the area gently 1-2 days before your appointment to remove dead skin cells and prevent ingrown hairs. Use a gentle scrub or exfoliating gloves. Avoid harsh exfoliation on the day of your appointment. \n \n 3. Avoid Moisturizers and Oils - Skip applying lotions, creams, or oils to the area on the day of your waxing. These can make it harder for the wax to adhere to the hair. \n \n 4. Shower Before Your Appointment - Clean skin is essential for an effective waxing session. Take a warm shower before your appointment to open up the pores, making hair removal easier. \n \n 5. Avoid Caffeine and Alcohol - Avoid consuming caffeine or alcohol at least a few hours before your appointment. They can make your skin more sensitive to pain. \n \n 6. Dress Comfortably - Wear loose-fitting clothing to avoid irritation after your waxing session, especially for areas like the bikini line or legs. \n \n 7. Communicate with Your Waxer - Inform your technician if you’re using any medications like Retinol, Accutane, or other skin treatments that might make your skin more sensitive. \n \n 8. Hydrate - Drink plenty of water to keep your skin hydrated , which can make the waxing process more comfortable.",
        },
        {
            title: "After your wax...",
            desc: "1. Soothe the Skin - Apply a cooling gel, like aloe vera or a post-wax lotion, to reduce redness and calm irritation. Avoid fragranced products, which can irritate freshly waxed skin.\n \n 2. Avoid Heat and Friction - Avoid hot showers, saunas, steam rooms, or hot tubs for at least 24-48 hours. Wear loose-fitting, breathable clothing to minimize irritation. Refrain from intense exercise or activities that cause excessive sweating, as this can irritate the skin. \n \n 3. Avoid Sun Exposure - Stay out of direct sunlight and avoid tanning beds for at least 48 hours. Freshly waxed skin is more sensitive to UV rays and prone to sunburn. If you need to go outside, apply a broad-spectrum sunscreen to protect the area. \n \n 4. Skip Harsh Products - Avoid exfoliants, scrubs, chemical peels, or retinol-based products on the waxed area for 48 hours to prevent irritation or sensitivity. Refrain from using deodorant on waxed underarms for a day or two. \n \n 5. Prevent Ingrown Hairs - After 48 hours, gently exfoliate the waxed area 2-3 times a week using a mild scrub or exfoliating glove to prevent ingrown hairs. Use products designed to reduce ingrown hairs, like those containing salicylic acid or tea tree oil. \n \n 6. Keep the Area Clean - Wash the area with mild soap and lukewarm water. Avoid overly hot or cold water. Pat dry instead of rubbing the area with a towel. \n \n 7. Moisturize - Keep the skin hydrated by applying a lightweight, fragrance-free moisturizer regularly. \n \n 8. Avoid Touching the Area - Resist the urge to touch or scratch the waxed area, as it can introduce bacteria and cause irritation or breakouts. \n \n 9. Plan Regular Maintenance - Waxing is most effective when done regularly. Schedule your next appointment in 4-6 weeks for consistent results.",
        },
        {
            title: "Cancellation Policy",
            desc: `Rescheduling or cancelling of your appointment made less than 24 hours prior to your appointments will be charged 50% of the full-service price of all appointments booked. If you do not show up for your appointment (no show) and did not call to cancel at least 30 minutes prior to the appointment, you will be charged 100% of the full-service price of all appointments booked. There is a five minute grace period for appointments. If you are past five minutes late, I may not be able to complete the service but I will do my absolute best to accommodate you. If you are running late or need ANY changes to your appointment, please give me a courtesy call versus "no showing" me. I understand life happens, we are all human and I understand things come up and communication goes a lot further than you know. Thank you for your understanding.`,
        },
    ]);

    return (
        <section
            id="faq"
            className="w-full flex flex-col justify-center px-6 md:px-10 pt-10  bg-peachDarkPink overflow-hidden"
        >
            <div className="text-5xl xxs:text-6xl  md:text-7xl lg:text-8xl  mb-3 font-semibold font-fredoka  text-center z-20">
                What to know
            </div>

            <div className="w-full max-w-7xl flex flex-col  z-20 mx-auto">
                <div className=" heading mb-3 font-fredoka font-semibold text-center md:text-start xl:self-start ">
                    Before your wax...
                </div>
                <div className="flex flex-col lg:flex-row w-full text-xl  md:text-2xl font-light justify-center">
                    <ul className="flex flex-col gap-3 pl-5 mb-5 list-disc">
                        <li>
                            Make sure you've grown your hair for two weeks after
                            your last shave. Hair should be 1/4 an inch
                            (approximately the length of a grain of rice).
                        </li>
                        <li>Exfoliate 1-2 days before your appointment</li>
                        <li>
                            If you have an event, I recommend 3 waxes before
                            said event
                        </li>
                        <li>
                            Wear loose fitting clothing to your wax appointment
                        </li>
                    </ul>
                    <div className="boots flex justify-end items-end self-center lg:self-end  -mb-10">
                        <img
                            className="object-cover"
                            src="/images/boots.png"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Faq;
